var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.languageClass,
      staticStyle: { "min-width": "1000px", overflow: "hidden" },
      attrs: { id: "app" },
      on: { drop: _vm.drop, dragover: _vm.drop }
    },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }